import { Form } from "react-bootstrap";
import PriceEditable from "../../PriceEditable/PriceEditable";
import React from "react";
import {
    MobilePositionParamEditorErrorStyled,
    MobilePositionParamEditorStyled
} from "./styled/MobilePositionParamEditorStyled";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

function MobilePositionParamEditor(props) {
    const {getLangPath} = useLangContext();
    const {label, comparePriceLabel, inputPriceLabel, error, ...priceEditableProps} = props;

    return <>
        <MobilePositionParamEditorStyled>
            <Form.Label>{label}</Form.Label>
            <PriceEditable {...priceEditableProps}/>
        </MobilePositionParamEditorStyled>
        {
            !!error && <MobilePositionParamEditorErrorStyled>
                {getLangPath(error, {
                    input_price: inputPriceLabel,
                    compare_price: comparePriceLabel,
                })}
            </MobilePositionParamEditorErrorStyled>
        }
    </>
}

export default MobilePositionParamEditor;
